
class exports.DependencyInjection

    constructor: () ->
        @parent = @parent ? null

        # List of class mappings.
        # This can be used to easily inject
        # custom child classes. Dependencies!
        #
        # For example:
        # If you have a Form viewmodel that creates a child
        # Layer viewmodel, we can default that viewmodel's class to
        # be one thing, but then can pass in a different class to
        # instantiate.
        #
        # This is super great when we want to extend one class in
        # a group of related objects, but still use the defaults
        # for everything else
        @dependencies = {}


        # Properties to remove when
        # serializing this object for json
        @_ignore_properties = [
            'parent'
            'dependencies'
            '_ignore_properties'
            '_keep_properties'
            '_transform_properties'
        ]

        # Only keep these explicit properties
        # when serializing this object for json
        @_keep_properties = []

        @_transform_properties = [
            (v) ->
                # if v is a TAFFY table, get the contents as an array
                if v instanceof TAFFY
                    v = v().get()

                return v

            (v) ->
                return ko.utils.unwrapObservable(v)
        ]




        @setInitialDeps()


    # Shortcut for ignoring properties for serialization
    ignore: (arr) ->
        arr = [arr] if not $.isArray arr
        @_ignore_properties.push v for v in arr


    # Shortcut for keeping properties for serialization
    keep: (arr) ->
        arr = [arr] if not $.isArray arr
        @_keep_properties.push v for v in arr


    # Shortcut for transforming properties for serialization
    transform: (arr) ->
        arr = [arr] if not $.isArray arr
        @_transform_properties.push v for v in arr


    ###
    This recursively cleans up KoModels for
    serialization. It'll remove any unwanted properties,
    or only keep ones you specifically want to keep.

    This is great, because it makes life a lot easier
    for handling data models that might be serialized
    ###
    _cleanUp: () ->
        definitely_ignore_keys = [
            'dependencies'
            'parent'
            '_ignore_properties'
            '_keep_properties'
            '_transform_properties'
        ]
        copy = $.extend true, {}, this

        for key, v of copy

            for fn in @_transform_properties
                v = fn(v, key)

            copy[key] = v

            if key in @_ignore_properties or
            key in definitely_ignore_keys or
            (@_keep_properties.length > 0 and
            key not in @_keep_properties)

                copy[key] = null
                delete copy[key]

            else if v instanceof DependencyInjection
                copy[key] = v._cleanUp()

            else if $.isArray v
                copy[key] = []
                for j, i in v
                    if j instanceof DependencyInjection
                        copy[key][i] = j._cleanUp()
                    else
                        copy[key][i] = j


            else if $.isPlainObject v
                copy[key] = {}
                for i, j of v
                    if j instanceof DependencyInjection
                        copy[key][i] = j._cleanUp()
                    else
                        copy[key][i] = j

            else if $.isFunction(v)
                copy[key] = null
                delete copy[key]

        return copy


    serialize: () ->
        return JSON.stringify @_cleanUp()


    # Copy in some dependencies
    syncDeps: (list) ->
        for k, v of list
            @dependencies[k] = v


    # Get the classname for a dependency
    getDep: (name) ->
        # First, see if parents has any deps defined for it.
        # This might seem weird, but that means we can import
        # dependencies at the top level of a string of viewmodels,
        # if we want, and have those deps carry all the way down
        if @parent? and @parent instanceof DependencyInjection
            cls = @parent.getDep(name)
            return cls if cls

        if not @dependencies[name]?
            return false

        if typeof @dependencies[name] is 'string'
            return App.loadClass @dependencies[name]

        return @dependencies[name]


    setInitialDeps: () -> #stub
        undefined

    implements: () ->
        # this can take any number of parameters, but normally only one
        # each must be a class or array
        for iface in arguments

            # the interface may be just an array of method names
            if iface instanceof Array
                methods = iface
                ifaceName = 'Array'

            # the interface may be a class (that is, a constructor)
            # coffeescript classes are represented by their constructors -
            # functions that return an instance of the class
            else if typeof iface is 'function'
                obj = new iface()
                methods = (k for k, v of obj when typeof v is 'function')
                ifaceName = obj.constructor.name

            # the interface could be an object I guess?? why not?
            else if iface instanceof Object
                methods = (k for k, v of iface when typeof v is 'function')
                ifaceName = iface.constructor.name

            else
                throw new Error("Invalid interface '#{iface}'")


            # enforce that interface methods are valid and are implemented
            for method in methods

                # name must be a string. using anything else sounds dumb, but I could be wrong??
                if typeof method isnt 'string'
                    throw new Error("Invalid method name '#{method}' in interface '#{ifaceName}'")

                # no private methods allowed
                if method.charAt(0) is '_'
                    throw new Error("Interfaces cannot specify private methods: method '#{method}' in interface '#{ifaceName}'")

                # see if it's defined
                if not this[method]?
                    throw new Error("Method '#{method}' of interface '#{ifaceName}' is not implemented")

                # see if it's actually a function
                if typeof this[method] isnt 'function'
                    throw new Error("Method '#{method}' of interface '#{ifaceName}' must be implemented as type 'function', not as type '#{typeof this[method]}'")
